module.exports = __webpack_public_path__ + "static/media/paypal_icon.c5f2ab31.svg";